"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CovidMask = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CovidMask = function CovidMask(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 19.522c-.468 0-.71.14-1.236.475l-.015.01c-.381.242-.882.56-1.593.805-.721.248-1.614.405-2.808.405a1 1 0 110-2c1.013 0 1.681-.133 2.158-.297.478-.164.81-.372 1.184-.61l.031-.02c.54-.343 1.206-.768 2.279-.768s1.74.425 2.279.768l.031.02c.375.238.706.447 1.184.61.477.164 1.145.297 2.158.297a1 1 0 110 2c-1.194 0-2.087-.157-2.808-.405-.711-.244-1.212-.563-1.593-.805l-.015-.01c-.526-.335-.768-.475-1.236-.475z",
    fill: "url(#CovidMask_svg__CovidMask_svg__paint0_linear_17373_95526)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22a1 1 0 100 2h6a1 1 0 100-2h-6z",
    fill: "url(#CovidMask_svg__CovidMask_svg__paint1_linear_17373_95526)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.582 16.397c2.657.076 4.381.97 5.09 2.476.713 1.515.173 3.2-.709 4.249-.477.567-1.125.994-1.76 1.317-.645.327-1.337.576-1.96.763a17.87 17.87 0 01-1.386.355c-.647 1.27-1.556 2.435-2.825 3.291-1.328.896-2.99 1.413-5.032 1.413-2.041 0-3.704-.517-5.031-1.413-1.27-.856-2.179-2.022-2.826-3.291-.388-.083-.87-.2-1.386-.355a12.066 12.066 0 01-1.96-.763c-.635-.323-1.283-.75-1.76-1.317-.882-1.05-1.422-2.734-.71-4.249.71-1.506 2.434-2.4 5.091-2.476a.894.894 0 01.104-.006c1.532 0 2.558-.268 3.308-.611.76-.348 1.294-.796 1.863-1.279l.058-.049C17.525 13.794 18.46 13 20 13s2.475.794 3.25 1.452l.057.049c.569.483 1.103.93 1.863 1.279.75.343 1.776.611 3.308.611.035 0 .07.002.104.006zm.876 2.07c-.056 1.452-.24 3.15-.712 4.796a9.918 9.918 0 001.552-.608c.513-.26.899-.54 1.134-.82.543-.646.715-1.505.43-2.11-.208-.443-.813-1.049-2.404-1.259zm-18.204 4.796c-.471-1.647-.656-3.344-.712-4.797-1.591.21-2.196.816-2.405 1.259-.284.605-.112 1.464.431 2.11.235.28.62.56 1.134.82a9.923 9.923 0 001.552.608zm6.733-7.237C18.808 15.329 19.237 15 20 15c.763 0 1.192.33 2.013 1.026l.02.018c.565.479 1.28 1.085 2.304 1.554.837.383 1.845.66 3.123.757-.073 1.964-.393 4.273-1.321 6.166-.535 1.093-1.258 2.017-2.226 2.67-.961.648-2.224 1.07-3.913 1.07-1.689 0-2.952-.422-3.913-1.07-.968-.653-1.69-1.577-2.226-2.67-.928-1.893-1.248-4.202-1.322-6.166 1.28-.096 2.287-.374 3.124-.757 1.024-.469 1.74-1.075 2.303-1.554l.021-.018z",
    fill: "url(#CovidMask_svg__CovidMask_svg__paint2_linear_17373_95526)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm0-2c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18z",
    fill: "url(#CovidMask_svg__CovidMask_svg__paint3_linear_17373_95526)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "CovidMask_svg__CovidMask_svg__paint0_linear_17373_95526",
    x1: 0,
    y1: 40,
    x2: 42.335,
    y2: 37.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CovidMask_svg__CovidMask_svg__paint1_linear_17373_95526",
    x1: 0,
    y1: 40,
    x2: 42.335,
    y2: 37.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CovidMask_svg__CovidMask_svg__paint2_linear_17373_95526",
    x1: 0,
    y1: 40,
    x2: 42.335,
    y2: 37.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CovidMask_svg__CovidMask_svg__paint3_linear_17373_95526",
    x1: 0,
    y1: 40,
    x2: 42.335,
    y2: 37.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7D7E"
  }))));
};

exports.CovidMask = CovidMask;
var _default = CovidMask;
exports.default = _default;